import { CombinedGraphQLErrors, ServerError } from '@apollo/client'
import { ErrorLink } from '@apollo/client/link/error'
import { setSessionData } from '@docpace/shared-react-utils/sessionUtils'

interface MakeApolloErrorLinkProps {}

export const makeApolloErrorLink = ({}: MakeApolloErrorLinkProps = {}) =>
    new ErrorLink(({ error }) => {
        if (CombinedGraphQLErrors.is(error)) {
            error.errors.forEach(({ message, locations, path }) => {
                console.log(
                    `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`
                )
            })
        } else {
            if(error.message?.includes('Socket closed with event 4500')) return
            console.log(`[Network error]: ${error}`)
            if (ServerError.is(error) && error.statusCode === 401) {
                if (window?.location?.pathname?.split('/')?.[1] === 'auth') return

                setSessionData(null).then(() => {})
                console.log('401 detected - redirecting..')
                window.location.replace('/auth')
            }
        }
    })
